class CartNotification extends HTMLElement {
    constructor() {
        super();

        this.notification_modal = new window.bootstrap5.Modal(document.getElementById('cart-notification'), {})
        this.notification = document.getElementById('cart-notification');
        this.onBodyClick = this.handleBodyClick.bind(this);
        this.onResize = this.updateOffsetPosition.bind(this);

        this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
        this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
            closeButton.addEventListener('click', this.close.bind(this))
        );

        window.addEventListener('resize', this.onResize);
        this.updateOffsetPosition();
    }

    open() {
        this.updateOffsetPosition();
        this.notification_modal.show();

        this.notification.addEventListener('transitionend', () => {
            this.notification.focus();
            trapFocus(this.notification);
        }, {once: true});

        document.body.addEventListener('click', this.onBodyClick);
    }

    close() {
        this.notification_modal.hide();

        document.body.removeEventListener('click', this.onBodyClick);

        removeTrapFocus(this.activeElement);
    }

    disconnectedCallback() {
        window.removeEventListener('resize', this.onResize);
    }

    updateOffsetPosition() {
        if (!this.notification) {
            return;
        }

        const parent = this.notification.parentElement;
        if (!parent) {
            return;
        }

        const parentRect = parent.getBoundingClientRect();
        const offsetFromViewportEdge = Math.max(window.innerWidth - parentRect.right, 0);
        const isRtl = document.documentElement.getAttribute('dir') === 'rtl';

        if (isRtl) {
            this.notification.style.left = `${offsetFromViewportEdge}px`;
            this.notification.style.removeProperty('right');
            return;
        }

        this.notification.style.right = `${offsetFromViewportEdge}px`;
        this.notification.style.removeProperty('left');
    }

    renderContents(parsedState) {
        this.cartItemKey = parsedState.key;
        this.getSectionsToRender().forEach((section => {
            const el = document.getElementById(section.id);
            el.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);

            if (el.classList.contains('hidden')) el.classList.remove('hidden');
        }));

        this.open();
    }

    getSectionsToRender() {
        return [
            {
                id: 'cart-notification-product',
                selector: `[id="cart-notification-product-${this.cartItemKey}"]`,
            },
            {
                id: 'cart-notification-button'
            },
            {
                id: 'cart-notification-price'
            },
            {
                id: 'cart-icon-bubble'
            },
            {
                id: 'cart-price'
            }
        ];
    }

    getSectionInnerHTML(html, selector = '.shopify-section') {
        return new DOMParser()
            .parseFromString(html, 'text/html')
            .querySelector(selector).innerHTML;
    }

    handleBodyClick(evt) {
        const target = evt.target;
        if (target !== this.notification && !target.closest('cart-notification')) {
            const disclosure = target.closest('details-disclosure, header-menu');
            this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
            this.close();
        }
    }

    setActiveElement(element) {
        this.activeElement = element;
    }
}

customElements.define('cart-notification', CartNotification);